import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Link from '../../../Link';
import Box from '../../../../shared/Box/index.tsx';
import { Caret } from '../../../../shared/Caret';
import IconBadge from '../../../IconBadge';
import { clickNavLink, clickedNavLinkGoogleAnalytics } from '../../events';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

const cx = classnames.bind(LinkStyles);

const scrollElementIntoView = id => {
  setTimeout(() => {
    const el = document.getElementById(id);
    el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
};

const NavLinks = ({ links, pathname }) => (
  <ul className={styles.navLinksList}>
    {links.map(link => {
      const {
        label,
        key,
        to,
        href,
        subLinks,
        isShowingNotificationBadge,
        notificationBadge,
        openInNewTab,
      } = link;
      return (
        <li key={key} className={styles.linkItem}>
          {!subLinks ? (
            <Link
              to={to}
              href={href}
              onClick={() => {
                clickNavLink({ link: key });
                clickedNavLinkGoogleAnalytics(label);
              }}
              className={cx({ link: true, linkActive: pathname === to })}
              target={openInNewTab ? '_blank' : '_self'}
            >
              <span>
                {label}
                {isShowingNotificationBadge && (
                  <Box
                    position="absolute"
                    top
                    right
                    marginTop={0}
                    marginRight={-10}
                  >
                    <IconBadge
                      backgroundColor="green"
                      iconColor="#292F36"
                      width={10}
                      padding={1}
                      type={notificationBadge}
                    />
                  </Box>
                )}
              </span>
            </Link>
          ) : (
            <span
              tabIndex={0}
              className={`withSubLinks ${cx({
                link: true,
                linkActive: pathname === to,
              })}`}
            >
              {label} {subLinks && <Caret className={LinkStyles.caret} />}
            </span>
          )}
          {subLinks && (
            <ul className={`subLinks ${styles.subLinks}`}>
              {subLinks.map(subLink => {
                const {
                  anchorId,
                  label: subLinkLabel,
                  to: subLinkTo,
                  svg,
                } = subLink;
                return (
                  <li className={styles.subLinkItem} key={subLinkLabel}>
                    <Link
                      to={subLinkTo}
                      className={`${styles.subLink}`}
                      onClick={() => {
                        clickedNavLinkGoogleAnalytics(subLinkLabel);
                        if (anchorId) scrollElementIntoView(anchorId);
                      }}
                    >
                      <span className={styles.subLinkContainer}>
                        {svg}
                        {subLinkLabel}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      );
    })}
  </ul>
);

NavLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      to: PropTypes.string,
      subLinks: PropTypes.arrayOf(
        PropTypes.shape({
          to: PropTypes.string,
          label: PropTypes.string,
          svg: PropTypes.element,
        })
      ),
      isShowingNotificationBadge: PropTypes.bool,
      notificationBadge: PropTypes.string,
    })
  ).isRequired,
  pathname: PropTypes.string.isRequired,
};

export { NavLinks };
